<template>
    <div class="login-screen">
        <header class="header -login">
            <div class="logo">
                FORK
                <br />YOU
            </div>
        </header>
        <transition name="fade">
            <div class="loading" v-if="performingRequest">
                <p>Loading ...</p>
            </div>
            <div class="login" v-else>
                <form class="login__form" @submit.prevent>
                    <input
                        type="email"
                        v-model="email"
                        placeholder="Email Address"
                        class="input"
                        required
                    />
                    <input
                        type="password"
                        v-model="password"
                        placeholder="Password"
                        class="input"
                        required
                    />
                    <button @click="login" class="button button--submit">Sign In</button>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");

export default {
    data() {
        return {
            email: "",
            password: "",
            performingRequest: false
        };
    },
    methods: {
        login() {
            this.performingRequest = true;

            fb.auth
                .signInWithEmailAndPassword(this.email, this.password)
                .then(user => {
                    console.log(user);
                    this.$store.commit("setCurrentUser", user.user);
                    this.$store.dispatch("fetchUserProfile");
                    this.$store.dispatch("setUsers");
                    this.performingRequest = false;
                    this.$router.replace("/");
                    this.$store.dispatch("initRecipes"); // need to change how this happens if recipes viewable without logging in

                    /*var promise = this.$store.dispatch("initRecipes");
                    const self = this;
                    promise.then(function() {
                        self.isLoading = false;
                        this.$router.replace("/");
                    });*/
                })
                .catch(error => {
                    alert(error);
                    this.performingRequest = false;
                });
        }
    }
};
</script>